/** Berkas submissions + berita-acara live queries. */

import { COL } from '../../collections';
import { where, orderBy, limit } from '../../collections';
import { useLiveQuery } from '../hooks';
import type { BeritaAcaraDoc, SubmissionDoc } from '../../types';

/** Uploaded berkas (submissions) for a skripsi. */
export function useSubmissions(skripsiId: string | null) {
  return useLiveQuery<SubmissionDoc>(
    skripsiId ? COL.submissions : null,
    skripsiId ? [where('skripsiId', '==', skripsiId), orderBy('createdAt', 'desc')] : [],
    Boolean(skripsiId),
  );
}

/** Berkas across all skripsi awaiting staff verification. */
export function usePendingSubmissions() {
  return useLiveQuery<SubmissionDoc>(COL.submissions, [
    where('status', '==', 'submitted'),
    orderBy('createdAt', 'desc'),
    limit(50),
  ]);
}

/** Berita acara / official documents for a skripsi. */
export function useBeritaAcaraFor(skripsiId: string | null) {
  return useLiveQuery<BeritaAcaraDoc>(
    skripsiId ? COL.beritaAcara : null,
    skripsiId ? [where('skripsiId', '==', skripsiId), orderBy('createdAt', 'desc')] : [],
    Boolean(skripsiId),
  );
}

/** All berita acara across the faculty (staf archive). */
export function useAllBeritaAcara() {
  return useLiveQuery<BeritaAcaraDoc>(COL.beritaAcara, [orderBy('createdAt', 'desc')]);
}
